// React
import React, {
  useState,
  useEffect,
  useContext,
  useMemo,
  useRef,
  useCallback,
} from "react";
// React
// CSS
import styles from "./TestTeachItemVideoShower.module.css";
import "./../TeachItemVideoShower/videoConfig.css";
// CSS
// Services
import { getPartsOfTeachItemWithIdService } from "../../Services/parts/get/getPartsOfTeachItemWithIdService";
// Services
// Contexts
import { UserTokenContext } from "../../Contexts/userToken";
// Contexts
// Modules
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
// Modules
// Models
import {
  I_Position,
  I_QuizMakerQuestions,
  I_TechItemPart,
  _Option,
} from "../../Models/interfaces";
// Models
// Components
import Swal from "sweetalert2";
import Comments from "../TeachItemVideoShower/Comments/Comments";
// Components
// Utils
import Spinner from "../../Utils/Spinner/Spinner";
import ReactPlayer from "react-player/file";
// Utils
// Icons
import { IoIosArrowDown } from "react-icons/io";
import { FiMonitor } from "react-icons/fi";
import Quiz from "../TeachItemVideoShower/Quiz/Quiz";
import Modal from "../TeachItemVideoShower/Modal/Modal";
import PlaybackModal from "../TeachItemVideoShower/PlaybackModal/PlaybackModal";
import { toast } from "react-toastify";
import AddCommentsModal from "../TeachItemVideoShower/Comments/AddCommentsModal/AddCommentsModal";
import { _parser } from "../../Utils/_parser";
import { _stringify } from "../../Utils/_stringify";
import {
  AllDataNeededContext,
  SetAllDataNeededContext,
} from "../../Contexts/AllDataNeededContext";
import { UAParser } from "ua-parser-js";
import { getUserProfile_Service } from "../../Services/Profile/get/getUserProfile_Service";
// Icons

type TeachItemVideoShowerProps = {
  setIsNeedFullScreen: React.Dispatch<React.SetStateAction<boolean>>;
  setUserQuestions: React.Dispatch<
    React.SetStateAction<I_QuizMakerQuestions[]>
  >;
};

const TestTeachItemVideoShower: React.FunctionComponent<
  TeachItemVideoShowerProps
> = ({ setIsNeedFullScreen }) => {
  const { browser } = UAParser(navigator.userAgent);
  // States
  const [userNumber, setUserNumber] = useState<string>("");
  const [teachData, setTeachData] = useState<I_TechItemPart>({
    data: [],
    data_count: 0,
    has_paid: false,
    lesson_id: 0,
    lesson_name: "",
    quiz: {
      award: 0,
      early_price: 0,
      gift_price: 0,
      grade_name: "",
      has_paid: false,
      id: 1,
      is_locked: false,
      price: 0,
      questions: [],
      Quiz_date: "",
      quiz_time: 1,
      shamsi_quiz_date: "",
      title: "",
      answer_file: "",
      grade_id: 1,
    },
    section_name: "",
    subject_name: "",
    subject_id: 0,
    teacher_id: 0,
    teacher_name: "",
  });
  const [currMode, setCurrMode] = useState<"quiz" | "media">("media");
  const [currDataIndex, setCurrDataIndex] = useState<number>(0);
  const [isPending, setIsPending] = useState<boolean>(true);
  const [playbackSpeed, setPlayBackSpeed] = useState<number>(100);
  const [isPlayBackSpeedModalInScreen, setIsPlayBackSpeedModalInScreen] =
    useState<boolean>(false);
  const [questionAnswer, setQuestionAnswer] = useState<_Option>({
    id: 0,
    image_url: "",
    is_correct: false,
    title: "",
  });
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isBuyQuizModalInScreen, setIsBuyQuizModalInScreen] =
    useState<boolean>(false);
  const [isCommentModalOpen, setIsCommentModalOpen] = useState<boolean>(false);

  const allDataNeeded = useContext(AllDataNeededContext);

  const setAllNeededData = useContext(SetAllDataNeededContext);

  const [isVideoPlaying, setIsVideoPlaying] = useState<boolean>(true);

  const [isVideoMuted] = useState<boolean>(false);

  const [currDuration, setCurrDioration] = useState<number>(0);

  const [numberPos, setNumberPos] = useState<I_Position>({
    top: "1rem",
    left: "5rem",
  });

  const [isControlsInScreen, setIsControlsInScreen] = useState<boolean>(false);

  // const [isVideoBuffering, setIsVideoBuffering] = useState<boolean>(false);

  const [isVideoFullScreen, setIsVideoFullScreen] = useState<boolean>(false);

  const [searchParams] = useSearchParams();

  const canvasRef = useRef<HTMLCanvasElement>(null);
  const divRef = useRef<HTMLDivElement>(null);
  // States
  /******************************************************** */
  /******************************************************** */
  /******************************************************** */
  /******************************************************** */
  /******************************************************** */
  // Constants
  const userToken = useContext(UserTokenContext);
  const { teachItemId } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();
  //
  function createMarkup(markup: string) {
    return { __html: markup };
  }
  //
  const videoElRef = useRef<any>(
    currMode === "media" ? document.querySelector("video")! : null
  );
  //
  const positions: I_Position[] = useMemo(
    () => [
      {
        top: "1rem",
        left: "5rem",
        zIndex: "20",
      },
      {
        top: "1rem",
        right: "5rem",
        zIndex: "20",
      },
      {
        bottom: "1rem",
        left: "5rem",
        zIndex: "20",
      },
      {
        bottom: "1rem",
        right: "5rem",
        zIndex: "20",
      },
      {
        bottom: "2rem",
        right: "6rem",
        zIndex: "20",
      },
      {
        bottom: "10%",
        right: "10vw",
        zIndex: "20",
      },
      {
        bottom: "20%",
        right: "30vw",
        zIndex: "20",
      },
      {
        bottom: "12%",
        right: "10vw",
        zIndex: "20",
      },
      {
        bottom: "10%",
        right: "10rem",
        zIndex: "20",
      },
      {
        top: "30%",
        left: "6rem",
        zIndex: "20",
      },
      {
        top: "60%",
        left: "10vw",
        zIndex: "20",
      },
      {
        top: "20%",
        left: "30vw",
        zIndex: "20",
      },
      {
        top: "40%",
        left: "10vw",
        zIndex: "20",
      },
      {
        top: "10%",
        left: "10rem",
        zIndex: "20",
      },
    ],
    []
  );
  // Constants
  /******************************************************** */
  /******************************************************** */
  /******************************************************** */
  const handleFullscreenChange = useCallback(() => {
    if (document.fullscreenElement === null && isVideoFullScreen) {
      console.log("Exited fullscreen mode");
      document.exitFullscreen();
      setIsVideoFullScreen(false);
      // Your code for handling the exit from fullscreen
    } else {
      return;
    }
  }, [isVideoFullScreen]);
  /******************************************************** */
  /******************************************************** */
  //
  const quiz = useMemo(
    () => (
      <Quiz
        createMarkup={createMarkup}
        currDataIndex={currDataIndex}
        questionAnswer={questionAnswer}
        setCurrDataIndex={setCurrDataIndex}
        setQuestionAnswer={setQuestionAnswer}
        teachData={teachData}
        onVideoSelected={() => {}}
      />
    ),
    [currDataIndex, teachData, questionAnswer]
  );
  //
  // const videoForIOS = useMemo(
  //   () => (
  //     <div className={`${styles.videoContainer} player-wrapper w-full `}>
  //       {currMode === "media" ? (
  //         <ReactPlayer
  //           url={
  //             teachData?.data[currDataIndex]?.is_video
  //               ? String(teachData?.data[currDataIndex]?.video_url).replace(
  //                   /(http[^\s])/i,
  //                   "https:"
  //                 )
  //               : ""
  //           }
  //           playing={true}
  //           volume={1}
  //           muted={false}
  //           controls={true}
  //           ref={videoElRef}
  //           config={{
  //             attributes: {
  //               controlsList: "nodownload",
  //             },
  //           }}
  //           height={"auto"}
  //           playbackRate={playbackSpeed / 100}
  //           onEnded={() => {
  //             setCurrDataIndex((prevState) => {
  //               toast("فیلم آموزشی تمام شد ، سوال را حل کنید");
  //               if (prevState === Number(teachData?.data.length) - 1) {
  //                 return prevState;
  //               }
  //               return prevState + 1;
  //             });
  //           }}
  //           onProgress={() => {}}
  //           onPause={() => {
  //             setIsVideoPlaying(false);
  //           }}
  //           onPlay={() => {
  //             setIsVideoPlaying(true);
  //           }}
  //         />
  //       ) : null}
  //     </div>
  //   ),
  //   [teachData, currMode, playbackSpeed, currDataIndex]
  // );
  //
  const videoForOther = useMemo(
    () => (
      <div className={`${styles.videoContainer} player-wrapper w-full `}>
        {currMode === "media" ? (
          <>
            <ReactPlayer
              url={`https://stage-api.amoozeshmelli.com/download-video/${searchParams.get(
                "videoId"
              )}`}
              playing={true}
              volume={1}
              muted={false}
              controls={false}
              ref={videoElRef}
              config={{
                attributes: {
                  controlsList: "nodownload",
                },
              }}
              height={"auto"}
              playbackRate={playbackSpeed / 100}
              onEnded={() => {
                setCurrDataIndex((prevState) => {
                  toast("فیلم آموزشی تمام شد ، سوال را حل کنید");
                  if (prevState === Number(teachData?.data.length) - 1) {
                    return prevState;
                  }
                  return prevState + 1;
                });
              }}
              onProgress={() => {}}
              onPause={() => {
                setIsVideoPlaying(false);
              }}
              onPlay={() => {
                setIsVideoPlaying(true);
              }}
              stopOnUnmount={true}
            />

            {/* <div dangerouslySetInnerHTML={{
                __html : 
            }}>

            </div> */}

            {/* <iframe
              src={"https://stage-api.amoozeshmelli.com/download-video/31"}
              title="xfa"
              className={`${styles.iframe}`}
              id="iframeOfVideo"
            ></iframe> */}
          </>
        ) : null}
      </div>
    ),
    [currMode, playbackSpeed, teachData.data.length, searchParams]
  );
  //

  /******************************************************** */
  /******************************************************** */
  /******************************************************** */
  /******************************************************** */
  /******************************************************** */
  //   LfeCycles
  useEffect(() => {
    getUserProfile_Service(userToken)
      .then(
        ({
          data: {
            data: { phone },
          },
        }) => {
          setUserNumber(phone);
        }
      )
      .catch((err) => {
        console.log(err);
      });
  }, [userToken]);
  //
  useEffect(() => {
    setIsNeedFullScreen(true);
    return () => {
      setIsNeedFullScreen(false);
    };
  }, [setIsNeedFullScreen, state, navigate]);
  //
  useEffect(() => {
    getPartsOfTeachItemWithIdService(userToken, String(teachItemId))
      .then(({ data }) => {
        // Update LocalStorage For better UX and Handling refresh
        setTeachData(data);
        setAllNeededData((prevState) => ({
          ...prevState,
          teacherId: data.teacher_id,
          teacherName: data.teacher_name,
          subjectId: data.subject_id,
          lessonId: data.lesson_id,
          lessonName: data.lesson_name,
          sectionName: data.subject_name,
        }));
        setTeachData(data);

        if (data.data[0].is_video === true) {
          setCurrMode("media");
        } else {
          setCurrMode("quiz");
        }
        setIsPending(false);
      })
      .catch((err) => {
        console.log(err);
        setIsPending(false);
        Swal.fire({ icon: "error", title: err.response.data.message });
        navigate("/");
      });
  }, [userToken, teachItemId, navigate, setAllNeededData]);
  //
  useEffect(() => {
    if (teachData?.data.length === 0) return;
    teachData?.data[currDataIndex].is_video === true &&
    String(teachData?.data[currDataIndex].video_url).length > 8
      ? setCurrMode("media")
      : setCurrMode("quiz");
  }, [currDataIndex, teachData, setCurrMode]);
  //
  useEffect(() => {
    setQuestionAnswer({
      id: 0,
      image_url: "",
      is_correct: false,
      title: "",
    });
  }, [currDataIndex]);
  //
  useEffect(() => {
    if (allDataNeeded.sectionName === "") return;
    const subject_name_str = _stringify(allDataNeeded.sectionName);
    const lesson_name_str = _stringify(allDataNeeded.lessonName);
    const lesson_id_str = _stringify(allDataNeeded.lessonId);
    const teacher_name_str = _stringify(allDataNeeded.teacherName);
    const teacher_id_str = _stringify(allDataNeeded.teacherId);
    const subject_id_str = _stringify(allDataNeeded.subjectId);
    localStorage.setItem(
      "selectedSubject",
      _stringify({
        id: subject_id_str,
        title: subject_name_str,
      })
    );
    localStorage.setItem("lessonId", lesson_id_str);
    const topImageUrl: any = String(
      _parser(
        localStorage.getItem("lessonData")
          ? localStorage.getItem("lessonData")
          : JSON.stringify("none")
      )
    );
    console.log("before");
    localStorage.setItem(
      "lessonData",
      _stringify({
        id: _parser(lesson_id_str),
        title: _parser(lesson_name_str),
        url: _parser(
          Boolean(topImageUrl.url) ? topImageUrl.url : JSON.stringify("none")
        ),
      })
    );
    console.log("after");

    localStorage.setItem("teacherId", teacher_id_str);
    localStorage.setItem("teacherName", teacher_name_str);

    // Update LocalStorage For better UX and Handling refresh
  }, [allDataNeeded]);
  //
  useEffect(() => {
    const video = document.querySelector("video")!;
    videoElRef.current = video;
    if (!video) return;
    video.addEventListener("contextmenu", (e) => {
      e.preventDefault();
      return false;
    });
    // video.addEventListener("durationchange", (e) => {
    //   console.log("duration Change", e);
    // });
    // video.classList.add("pointer-events-none");
    // video.classList.add("relative");
    // video.classList.add("z-10");
    // // video.addEventListener("contextmenu", (event) => {
    //   event.preventDefault();
    //   return false;
    // });
    // //
    // video.addEventListener("dragstart", (event) => {
    //   event.preventDefault();
    //   return false;
    // });
    // //
    // video.addEventListener("drag", (event) => {
    //   event.preventDefault();
    //   return false;
    // });
    //
  });
  //
  useEffect(() => {
    if (String(browser.name).toLocaleLowerCase().includes("safari")) return;
    if (currMode === "quiz") return;
    if (isPending) return;
    if (!canvasRef.current) return;
    if (!divRef.current) return;
    const _video = videoElRef.current;
    // _video.src = String(teachData.data[currDataIndex].video_url).replace(
    //   /(http[^\s])/i,
    //   "https:"
    // );
    // _video.controls = false;
    // _video.playbackRate = playbackSpeed / 100;
    // _video.addEventListener("ended", () => {
    //   setCurrDataIndex((prevState) => {
    //     toast("فیلم آموزشی تمام شد ، سوال را حل کنید");
    //     if (prevState === Number(teachData?.data.length) - 1) {
    //       return prevState;
    //     }
    //     return prevState + 1;
    //   });
    // });
    // _video.addEventListener("progress", () => {});
    // _video.addEventListener("loadstart", () => {
    //   setIsVideoBuffering(true);
    // });
    // _video.addEventListener("loadeddata", () => {
    //   setIsVideoBuffering(false);
    // });
    // _video.style.width = "100px";
    // _video.style.height = "100px";
    const canvas = canvasRef.current;
    // const div = divRef.current!;
    const ctx = canvas.getContext("2d")!;

    const drawFrame = () => {
      ctx.drawImage(_video, 0, 0, canvas.width, canvas.height);
      ctx.imageSmoothingEnabled = true;
      requestAnimationFrame(drawFrame);
    };

    _video.addEventListener("play", drawFrame);

    return () => {
      _video.removeEventListener("play", drawFrame);
    };
  }, [
    currMode,
    isPending,
    currDataIndex,
    playbackSpeed,
    teachData.data,
    browser.name,
  ]);
  //
  useEffect(() => {
    if (String(browser.name).toLocaleLowerCase().includes("safari")) return;
    window.addEventListener("orientationchange", (event: any) => {
      const footer = document.getElementById("footer");
      if (event.target.screen.orientation.angle !== 0) {
        if (!videoElRef.current) return;
        if (!canvasRef.current) return;
        if (!footer) return;
        footer.style.display = "none";
        canvasRef.current.style.width = `${window.innerWidth}px`;
        canvasRef.current.style.height = `${window.innerHeight}px`;
        videoElRef.current.style.width = `${window.innerWidth}px`;
        videoElRef.current.style.height = `${window.innerHeight}px`;

        return;
      }
    });
  }, [browser.name]);
  //
  useEffect(() => {
    if (String(browser.name).toLocaleLowerCase().includes("safari")) return;
    if (currMode !== "media") return;
    if (!isVideoPlaying) return;
    const timeOut = setTimeout(() => {
      setCurrDioration((prevState) => prevState + 1);
    }, 1000);

    return () => {
      clearTimeout(timeOut);
    };
  }, [isVideoPlaying, currDuration, currMode, browser.name]);
  //
  useEffect(() => {
    setCurrDioration(0);
  }, [currMode, currDataIndex]);
  //
  useEffect(() => {
    const videoElContainer = document.querySelector(".player-wrapper")!;
    if (!videoElContainer) return;

    if (isVideoFullScreen) {
      videoElContainer.classList.add("full");
      return;
    }

    videoElContainer.classList.remove("full");
  }, [isVideoFullScreen]);
  //
  useEffect(() => {
    if (currMode !== "media") return;
    const timeOut = setInterval(() => {
      const randomIndex = Math.round(Math.random() * positions.length - 1);
      setNumberPos(positions[randomIndex]);
    }, 4000);
    return () => {
      clearTimeout(timeOut);
    };
  }, [currMode, isVideoPlaying, numberPos, userToken, positions]);
  //
  useEffect(() => {
    if (window.screen.orientation.angle === 0) return;
    Swal.fire({
      icon: "info",
      text: "لطفا صفحه ی موبایل خود را بچرخانید",
    });
  }, [isVideoFullScreen]);
  //
  useEffect(() => {
    if (currMode !== "media") return;
    if (isControlsInScreen === false) return;
    let timeOut1: any;
    let timeOut2: any;
    const timeOut = setTimeout(() => {
      const overlay = document.getElementById("overlay")!;
      overlay.style.opacity = "1";
      overlay.style.visibility = "visible";
      timeOut1 = setTimeout(() => {
        overlay.style.opacity = "0";
        overlay.style.visibility = "hidden";
        timeOut2 = setTimeout(() => {
          setIsControlsInScreen(false);
        });
      }, 3000);
    }, 100);

    return () => {
      if (timeOut) {
        clearTimeout(timeOut);
      }
      if (timeOut1) {
        clearTimeout(timeOut1);
      }
      if (timeOut2) {
        clearTimeout(timeOut2);
      }
    };
  }, [
    currDuration,
    currMode,
    isVideoPlaying,
    isVideoMuted,
    isControlsInScreen,
  ]);
  //
  useEffect(() => {
    document.addEventListener("fullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, [handleFullscreenChange]);
  //
  useEffect(() => {
    if (!isControlsInScreen) return;
    console.log(isControlsInScreen);
    const timeOut = setTimeout(() => {
      setIsControlsInScreen(false);
    }, 5000);

    return () => {
      clearTimeout(timeOut);
    };
  }, [isControlsInScreen]);
  //
  //   useEffect(() => {
  //     const iframe = document.querySelector("iframe");
  //     if (!iframe) return;

  //     const cssLink = document.createElement("link");
  //     cssLink.href = "./TestTeachItemVideoShower.module.css";
  //     cssLink.rel = "stylesheet";
  //     cssLink.type = "text/css";
  //     if (!iframe.contentWindow) {
  //       console.clear();
  //       console.log("xxxx");
  //       return;
  //     }

  //     iframe.contentWindow.document.body.appendChild(cssLink);
  //     if (isVideoFullScreen) {
  //       iframe.classList.add("fullImportant");
  //     } else {
  //       iframe.classList.remove("fullImportant");
  //     }
  //   }, [isVideoFullScreen]);
  //   LfeCycles
  /******************************************************** */
  /******************************************************** */
  /******************************************************** */
  /******************************************************** */
  /******************************************************** */
  return (
    <>
      <div
        className={`${styles.teachItemMasterContainer} w-screen h-screen overflow-y-hidden relative flex flex-col  justify-start dark:!text-black`}
      >
        {isPending ? (
          <span className="flex flex-col py-10 items-center justify-center bg-red-200 mt-10">
            <span className="my-5 text-xl">در حال بارگیری</span>
            <Spinner />
          </span>
        ) : (
          <>
            <div className={`${styles.topMainContainer} relative`}>
              {currMode === "media" ? (
                <>
                  <div
                    className="w-full relative"
                    id="videoContainer"
                    onClick={() => {
                      setIsControlsInScreen(true);
                    }}
                    onDoubleClick={() => {
                      const videoContainer =
                        document.querySelector("#videoContainer");

                      if (isVideoFullScreen) {
                        document
                          .exitFullscreen()
                          .then(() => {
                            if (!videoContainer) return;
                            window.screen.orientation?.unlock();
                            console.log("exited from F Screen");
                            setIsVideoFullScreen(false);
                          })
                          .catch((err) => {
                            console.log(err);
                          });
                        return;
                      }
                      if (!videoContainer) return;
                      videoContainer
                        .requestFullscreen()
                        .then(() => {
                          console.log("got F Screen");
                          setIsVideoFullScreen(true);
                        })
                        .catch((err) => {
                          console.log(err);
                        });

                      console.log("db c");
                    }}
                  >
                    <>
                      <>
                        {/* VIDEO CONTROLS */}
                        <div className="w-full !pointer-events-auto">
                          <div className="pointer-events-none w-full">
                            {videoForOther}
                            <p
                              className="absolute text-white !pointer-events-none "
                              id="userNumber"
                              style={{ ...numberPos }}
                            >
                              {userNumber}
                            </p>
                          </div>
                          <>
                            {/* {isControlsInScreen ? (
                              <div className="absolute bottom-0 z-20 w-full">
                                <div
                                  className={`${styles.overlay} z-20 absolute bg-[#000000cb] w-full h-[3rem]  !bottom-0 left-0 flex items-center justify-between px-2 transition-all`}
                                  id="overlay"
                                >
                                  {isVideoPlaying ? (
                                    <BsPause
                                      className=" text-2xl text-white "
                                      onClick={() => {
                                        setIsVideoPlaying(false);
                                        videoElRef.current.pause();
                                      }}
                                    />
                                  ) : (
                                    <BiPlay
                                      className=" text-2xl text-white rounded-full"
                                      onClick={() => {
                                        setIsVideoPlaying(true);
                                        videoElRef.current
                                          .play()
                                          .then(() => {
                                            console.log("videoPlayed");
                                          })
                                          .catch((err: any) => {
                                            console.log(err);
                                          });
                                      }}
                                    />
                                  )}
                                  <input
                                    type="range"
                                    id=""
                                    min={0}
                                    step={1}
                                    max={((): number => {
                                      const video =
                                        document.querySelector("video");
                                      if (video) return video.duration;
                                      return 10;
                                    })()}
                                    onChange={(e) => {
                                      const video =
                                        document.querySelector("video")!;
                                      video.currentTime = Number(
                                        e.target.value
                                      );
                                      console.log(e.target.value);
                                      setCurrDioration(e.target.valueAsNumber);
                                    }}
                                    value={currDuration}
                                    className="!w-[65vw] !bg-transparent slider1"
                                  />
                                  {isVideoMuted ? (
                                    <IoVolumeMuteOutline
                                      onClick={() => {
                                        const video =
                                          document.querySelector("video")!;
                                        video.muted = false;
                                        setIsVideoMuted(false);
                                        video.volume = Number(1);
                                      }}
                                      className=" text-2xl text-white rounded-full "
                                    />
                                  ) : (
                                    <VscUnmute
                                      onClick={() => {
                                        const video =
                                          document.querySelector("video")!;
                                        video.muted = true;
                                        setIsVideoMuted(true);
                                        video.volume = Number(0);
                                      }}
                                      className="text-2xl text-white rounded-full  "
                                    />
                                  )}
                                  <BsFullscreen
                                    className="text-2xl text-white "
                                    onClick={() => {
                                      const videoContainer =
                                        document.querySelector(
                                          "#videoContainer"
                                        );
                                      if (isVideoFullScreen) {
                                        document
                                          .exitFullscreen()
                                          .then(() => {
                                            if (!videoContainer) return;

                                            window.screen.orientation?.unlock();
                                            console.log("exited from F Screen");
                                            setIsVideoFullScreen(false);
                                          })
                                          .catch((err) => {
                                            console.log(err);
                                          });
                                        return;
                                      }
                                      if (!videoContainer) return;
                                      videoContainer
                                        .requestFullscreen()
                                        .then(() => {
                                          console.log("got F Screen");

                                          setIsVideoFullScreen(true);
                                        })
                                        .catch((err) => {
                                          console.log(err);
                                        });

                                      console.log("db c");
                                    }}
                                  />
                                </div>
                              </div>
                            ) : null} */}
                          </>
                        </div>
                        {/* VIDEO CONTROLS */}
                      </>
                    </>
                  </div>
                </>
              ) : null}
              {currMode === "quiz" ? (
                <>
                  {/* QUIZ CONTAINER */}
                  {quiz}
                  {/* QUIZ CONTAINER */}
                </>
              ) : null}
              <button
                className={`${
                  styles.buttonForChangeSection
                } absolute -bottom-8 left-4 px-2 text-white text-xs flex flex-row items-center ${
                  isModalOpen ? "z-0" : "z-10"
                } ${currMode === "quiz" ? "-bottom-8" : styles.bottomManager}`}
                onClick={() => {
                  setIsModalOpen(true);
                }}
              >
                قسمت {currDataIndex + 1} از {teachData?.data.length}
                <IoIosArrowDown className="ml-2" />
              </button>
              {/*  */}
              {currMode === "media" ? (
                <>
                  <button
                    className={`${
                      styles.buttonForChangeSection
                    } absolute  right-4 px-2 text-white text-xs flex flex-row items-center ${
                      isModalOpen ? "z-0" : "z-10"
                    } `}
                    onClick={() => {
                      setIsPlayBackSpeedModalInScreen(true);
                    }}
                  >
                    <span>
                      <span className="mr-1">{playbackSpeed / 100}x</span>{" "}
                      <span>سرعت پخش</span>
                    </span>
                    <IoIosArrowDown className="ml-2" />
                  </button>
                </>
              ) : (
                <></>
              )}
            </div>

            <div
              className={`${styles.sectionManagerContainer} relative ${
                currMode === "quiz" ? "mt-4" : ""
              }`}
            >
              {/*  */}
              {/*  */}
              {/*  */}
              {/*  */}
              {/*  */}
              {/*  */}
              {/*  */}
              {/*  */}
              {/*  */}
              {/* Modal controller */}

              {/*  */}
              {/*  */}
              {/* PartSelectorModal */}
              {/* {isModalOpen ? (
                <ModalForPartSelecting
                  data={teachData ? teachData?.data : []}
                  setIsModalOpen={setIsModalOpen}
                  setCurrMode={setCurrMode}
                  setCurrDataIndex={setCurrDataIndex}
                />
              ) : null} */}

              {isPlayBackSpeedModalInScreen ? (
                <PlaybackModal
                  setIsPlayBackSpeedModalInScreen={
                    setIsPlayBackSpeedModalInScreen
                  }
                  setPlayBackSpeed={setPlayBackSpeed}
                />
              ) : null}
              {/* PartSelectorModal */}
              {/*  */}
              {/*  */}
              {/* QuizShopModal */}
              {isBuyQuizModalInScreen === true ? (
                <>
                  <Modal
                    setIsBuyQuizModalInScreen={setIsBuyQuizModalInScreen}
                    quizData={teachData?.quiz}
                    lessonName={""}
                    subjectName={teachData?.section_name ?? ""}
                  />
                </>
              ) : null}
              {/* QuizShopModal */}
              {/* Modal controller */}
              {/*  */}
              {/*  */}
              {/*  */}
              {/*  */}
              {/*  */}
              {/*  */}
              {/*  */}
              {/*  */}
              {/*  */}
              {/* Main Content */}
              <div
                className={`${styles.mainContent} p-6 pb-0 flex flex-col items-end`}
              >
                <p className="flex flex-row-reverse items-center justify-start">
                  <FiMonitor />
                  <span className="mr-2 text-base">
                    {teachData?.section_name}
                  </span>
                </p>
                <p className="flex flex-row-reverse text-xs mt-2 text-gray-700">
                  <span>{teachData?.lesson_name}</span>
                  {" - "}
                  <span>{teachData?.subject_name}</span>
                </p>
                <p className="text-xs mt-1 text-gray-700">
                  <span>مدرس :</span>
                  <span>{allDataNeeded.teacherName}</span>
                </p>

                <div className="w-full flex items-center justify-between mt-4">
                  <button
                    className={`text-xs transition-all py-2 px-4 rounded-lg text-white ${
                      isModalOpen ? "z-0" : "z-10"
                    } ${styles.midBtn}`}
                    style={{ background: "rgb(76 , 175 ,80)" }}
                    onClick={() => {
                      setIsBuyQuizModalInScreen(true);
                    }}
                  >
                    آزمون پایانی این بخش
                  </button>
                  <button
                    className={`text-xs transition-all py-2 px-4 rounded-lg text-white ${
                      isModalOpen ? "z-0" : "z-10"
                    } ${styles.midBtn}`}
                    style={{ background: "blueviolet" }}
                    onClick={() => {
                      navigate(-1);
                    }}
                  >
                    بازگشت
                  </button>
                </div>
              </div>
              {/* Main Content */}
            </div>
            {/*  */}
            {/*  */}
            {/*  */}
            {/*  */}
            {/*  */}
            {/*  */}
            {/*  */}
            {/*  */}
            {/*  */}
            <Comments
              isModalOpen={isModalOpen}
              // currMode={currMode}
              // teacherName={allDataNeeded.teacherName}
              // _lessonData={String(
              //   `${teachData?.lesson_name} ${teachData?.subject_name}`
              // )}
              // sectionId={String(teachItemId)}
              setIsCommentModalOpen={setIsCommentModalOpen}
            />
          </>
        )}

        {isCommentModalOpen ? (
          <AddCommentsModal
            setIsModalInScreen={setIsCommentModalOpen}
            _lessonData={String(
              `${teachData?.lesson_name} ${teachData?.subject_name}`
            )}
            teacherName={
              String(_parser(localStorage.getItem("teacherName"))) ||
              allDataNeeded.teacherName
            }
            sectionId={String(teachItemId)}
          />
        ) : null}
      </div>
    </>
  );
};

export default TestTeachItemVideoShower;
